import * as types from "../constants/ActionTypes";

const tmnoreplyPerAgent = (state = [], action) => {
  switch (action.type) {
    case types.ADD_TMNOREPLY_PER_AGENT:
      return [...action.data];
    default:
      return state;
  }
};

export default tmnoreplyPerAgent;
